import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  modalRoot: {
    position: "relative",
    width: "100vw",
    height: "100vh",
    background: theme.palette.background.primary,
    overflow: "auto",
  },
  headingContainer: {
    display: "flex",
    padding: "24px 24px 0",
  },
  titlesWrapper: {
    width: "100% !important",
    position: "relative",
  },
  dialogTitleWrapper: {
    padding: "0 !important",
  },
  dialogTitle: {
    fontSize: "18px",
    lineHeight: "28px",
    fontWeight: 600,
    color: theme.palette.text.primary,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  subtitle: {
    marginTop: "4px",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    color: theme.palette.text.tertiary,
  },
  containerTitle: {
    display: "flex",
    justifyContent: "start",
  },
  //   closeBtn: {
  //     position: "absolute",
  //     top: 16,
  //     right: 16,
  //     color: "#222",
  //     zIndex: 10,
  //   },
  thumbnailsRow: {
    display: "flex",
    
    gap: 16,
    padding: "32px 100px 8px 100px",
    background: theme.palette.background.primary,
    // borderBottom: `1px solid ${theme.palette.divider}`,  put a divider instead
    alignItems: "flex-end",
    flexWrap: "wrap",
  },
  thumbnailBox: {
    minWidth: 100,
    minHeight: 70,
    maxWidth: 120,
    maxHeight: 90,
    borderRadius: 8,
    overflow: "hidden",
    background: "#eee",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
    marginBottom: 4,
  },
  thumbnailImg: {
    width: "100%",
    height: 60,
    objectFit: "cover",
    borderRadius: 8,
  },
  dialogActions: {
    justifyContent: "flex-end",
    padding: "32px 100px 8px 100px !important",
    gap: "12px",
  },
  gridImages: {
    display: "flex",
    flexDirection: "column",
    gap: 24,
    padding: "32px 100px 8px 100px",
    background: theme.palette.background.primary,
    justifyItems: "center",
  },

  imageSection: {
    display: "grid",
    gridTemplateColumns: "2fr 1fr",
    gap: 24,
    width: "100%",
    alignItems: "stretch",
  },

  leftColumn: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr 1fr",
    gap: 24,
  },

  rightColumn: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 569,
    background: "#eee",
    borderRadius: 12,
  },
  gridImg: {
    width: "100%",
    height: "100%",
    borderRadius: 12,
  },
  containerItemImageLeft: {
    height: 272.5,
    width: "100%",
    background: "#eee",
    borderRadius: 12,
  },
}));
